import React, { FC, useEffect, useMemo, useRef } from 'react'

// COMPONENTS
import Button from '@components/atoms/button'


interface ErrorModalError {
    name?: string
    message?: string
}

interface Props extends React.HTMLAttributes<HTMLDialogElement> {
    state: [boolean, React.Dispatch<React.SetStateAction<boolean>>]
    error?: ErrorModalError
    title?: string
    fallbackMessage?: string
    confirmLabel?: string
    onClose?: () => void
    getTitle?: (error?: ErrorModalError) => string
    getMessage?: (error?: ErrorModalError) => string
}

const ErrorModal: FC<Props> = (props) => {
    const {
        state,
        error,
        title,
        fallbackMessage,
        confirmLabel = 'Okay',
        onClose,
        getTitle,
        getMessage,
        ...dialogProps
    } = props
    const ref = useRef<HTMLDialogElement>(null)
    const [isOpen, setIsOpen] = state

    useEffect(() => {
        if (!ref.current) return
        if (isOpen) ref.current.showModal()
        else ref.current.close()
    }, [isOpen])

    const heading = useMemo(() => {
        if (getTitle) return getTitle(error)
        return title || 'Wait!'
    }, [error, getTitle, title])

    const body = useMemo(() => {
        if (getMessage) return getMessage(error)
        return error?.message || fallbackMessage || 'We encountered an issue. Please try again later.'
    }, [error, fallbackMessage, getMessage])

    function handleClose() {
        setIsOpen(false)
        if (onClose) onClose()
    }

    return (
        <dialog ref={ref} onClose={handleClose} {...dialogProps}>
            <div>
                <form
                    className="flex flex-col items-stretch"
                    method="dialog"
                    style={{ maxWidth: 'calc(var(--max-content-width, 610px) - 8rem)', borderRadius: 'var(--border-radius)', background: 'var(--splitcard-white)', overflowY: 'auto', textAlign: 'left', padding: '1.3125rem', margin: '1rem', gap: '1rem' }}
                >
                    <h2>{heading}</h2>
                    <p>{body}</p>
                    <Button type="submit">{confirmLabel}</Button>
                </form>
            </div>
        </dialog>
    )
}

export default ErrorModal
